import React from "react";
import "./TermsOfService.css";

const TermsOfService = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1>Terms of Service</h1>
        <p className="effective-date">Effective Date: April 1, 2025</p>

        <section className="terms-section">
          <h2>1. Introduction</h2>
          <p>
            Welcome to Diviti Adora Infrared & Red Light Studio. By accessing or
            using our services, you agree to comply with and be bound by these
            Terms of Service ("Terms"). Please read these Terms carefully. If
            you do not agree with any part of these Terms, you must not use our
            services.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. Services Provided</h2>
          <p>
            Diviti Adora Infrared & Red Light Studio offers infrared sauna
            sessions, red light therapy treatments, and related wellness
            services (collectively, the "Services"). We reserve the right to
            modify or discontinue any Service at any time without notice.
          </p>
        </section>

        <section className="terms-section">
          <h2>3. User Eligibility and Account Registration</h2>
          <p>
            <strong>Eligibility:</strong> You must be at least 18 years old (or
            the age of majority in your jurisdiction) to use our Services.
          </p>
          <p>
            <strong>Account Registration:</strong> Some Services may require
            registration. You agree to provide accurate, current, and complete
            information during registration and to update such information
            promptly if it changes. You are responsible for maintaining the
            confidentiality of your account credentials and for all activities
            under your account.
          </p>
          <p>
            <strong>Studio Communications:</strong> When you agree to these
            Terms during registration, booking, or purchase flows, you consent
            to receive Diviti Adora studio communications by email and SMS,
            including booking confirmations, reminders, account notices,
            service updates, and other operational studio communications. You
            may update your communication preferences in your profile at any
            time.
          </p>
        </section>

        <section className="terms-section">
          <h2>4. Payment and Refunds</h2>
          <p>
            <strong>Fees:</strong> Fees for our Services are as posted on our
            website or in our studio. Prices are subject to change without
            notice.
          </p>
          <p>
            <strong>Payment Terms:</strong> Payment must be made in full prior
            to receiving the Service.
          </p>
          <p>
            <strong>Refunds and Cancellations:</strong> Refund and cancellation
            policies are outlined separately on our website and at the time of
            booking. Please review these policies carefully before making a
            purchase or scheduling a session.
          </p>
        </section>

        <section className="terms-section">
          <h2>5. Health, Safety, and Disclaimers</h2>
          <p>
            <strong>Medical Disclaimer:</strong> The Services offered by Diviti
            Adora Infrared & Red Light Studio are not intended to diagnose,
            treat, cure, or prevent any disease. You are strongly encouraged to
            consult with a healthcare professional before starting any new
            wellness treatment, especially if you have pre-existing health
            conditions or are pregnant.
          </p>
          <p>
            <strong>Assumption of Risk:</strong> By using our Services, you
            acknowledge and assume the risks associated with infrared and red
            light therapies, including potential adverse effects.
          </p>
          <p>
            <strong>Safety Guidelines:</strong> You agree to follow all posted
            safety guidelines and instructions provided by our staff. Failure to
            adhere to these guidelines may result in injury, for which Diviti
            Adora Infrared & Red Light Studio will not be held liable.
          </p>
        </section>

        <section className="terms-section">
          <h2>6. User Responsibilities</h2>
          <p>
            <strong>Proper Use:</strong> You agree to use our Services in a
            manner consistent with all applicable laws and regulations.
          </p>
          <p>
            <strong>Conduct:</strong> You are expected to behave respectfully
            towards staff and other patrons. Any behavior deemed disruptive or
            unsafe may result in termination of your access to our Services.
          </p>
          <p>
            <strong>Personal Information:</strong> You are responsible for any
            information you share during your use of our Services. Please refer
            to our Privacy Policy for details on how we collect and use your
            personal data.
          </p>
        </section>

        <section className="terms-section">
          <h2>7. Intellectual Property</h2>
          <p>
            All content, trademarks, and logos displayed on our website and
            within our studio are the property of Diviti Adora Infrared & Red
            Light Studio or its licensors. You agree not to reproduce,
            distribute, or create derivative works from any of our intellectual
            property without express written permission.
          </p>
        </section>

        <section className="terms-section">
          <h2>8. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, Diviti Adora Infrared & Red
            Light Studio, its directors, employees, or agents shall not be
            liable for any indirect, incidental, consequential, or punitive
            damages arising out of or related to your use of the Services. Our
            total liability, whether in contract, tort, or otherwise, shall not
            exceed the amount paid by you for the Services giving rise to the
            claim.
          </p>
        </section>

        <section className="terms-section">
          <h2>9. Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless Diviti Adora Infrared & Red
            Light Studio, its affiliates, and their respective officers,
            directors, employees, and agents from any claims, liabilities,
            damages, or expenses (including reasonable attorneys' fees) arising
            out of your use of our Services or your breach of these Terms.
          </p>
        </section>

        <section className="terms-section">
          <h2>10. Termination</h2>
          <p>
            We reserve the right to terminate or suspend your access to our
            Services, with or without notice, for any reason, including if you
            violate these Terms. Upon termination, all provisions of these Terms
            that by their nature should survive termination will remain in
            effect.
          </p>
        </section>

        <section className="terms-section">
          <h2>11. Changes to the Terms</h2>
          <p>
            Diviti Adora Infrared & Red Light Studio reserves the right to
            modify these Terms at any time. Updated versions will be posted on
            our website with the effective date. Your continued use of the
            Services after changes are posted constitutes your acceptance of the
            new Terms.
          </p>
        </section>

        <section className="terms-section">
          <h2>12. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with
            the laws of the jurisdiction in which Diviti Adora Infrared & Red
            Light Studio operates, without regard to its conflict of law
            principles.
          </p>
        </section>

        <section className="terms-section">
          <h2>13. Contact Information</h2>
          <p>
            For any questions or concerns regarding these Terms or our Services,
            please contact us at:
          </p>
          <address>
            Diviti Adora Infrared & Red Light Studio
            <br />
            1930 E Tangerine Rd
            <br />
            Suite 100
            <br />
            Oro Valley, AZ 85737
            <br />
            Email:{" "}
            <a href="mailto:info@divitiadora.com">info@divitiadora.com</a>
          </address>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
